import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultComponent } from './default.component';
import { DashboardComponent } from 'src/app/modules/dashboard/dashboard.component';
import { RouterModule } from '@angular/router';
import { AdmitagentComponent } from 'src/app/modules/admitagent/admitagent.component';
import { PostsComponent } from 'src/app/modules/posts/posts.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSidenavModule, MatDividerModule, MatCardModule, MatPaginatorModule, MatTableModule, MatInputModule, MatGridListModule, MatButtonModule, MatIconModule, MatSortModule, MatOptionModule, MatSelectModule, MatListModule, MatSlideToggleModule, } from '@angular/material'
// import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginComponent } from 'src/app/login/login.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { AuthGuard } from 'src/app/modules/service/authguard';
import { HttpClientModule } from '@angular/common/http';
import { CustomersComponent } from 'src/app/modules/customers/customers.component';
import { StickerlistingsComponent } from 'src/app/modules/stickerlistings/stickerlistings.component';
import { RegisteredagentsComponent } from 'src/app/modules/registeredagents/registeredagents.component';
import { AgtransactionsComponent } from 'src/app/modules/agtransactions/agtransactions.component';
import { NewcustomerComponent } from 'src/app/modules/newcustomer/newcustomer.component';
import { SendnotificationsComponent } from 'src/app/modules/sendnotifications/sendnotifications.component';
import { ChartService } from 'src/app/modules/service/chart.service';
import { TpagtService } from 'src/app/modules/service/tpagtservice.service';
import { StickerService } from 'src/app/modules/service/stickerservice.service';
import { PolicyService } from 'src/app/modules/service/policyservice.service';
import { ClaimsportalComponent } from '../../modules/claimsportal/claimsportal.component'
import { ManagerSetPasswordComponent } from 'src/app/manager-set-password/manager-set-password.component';
import { ManagerExpiredLinkComponent } from 'src/app/manager-expired-link/manager-expired-link.component';
import { ManagerPasswordsetSuccessComponent } from 'src/app/manager-passwordset-success/manager-passwordset-success.component';
import { SignupmanagerComponent } from 'src/app/modules/signupmanager/signupmanager.component';
import { ManagerstblComponent } from 'src/app/modules/managerstbl/managerstbl.component';
import * as moment from 'moment';
import { NgxPaginationModule } from 'ngx-pagination';
import { ManagerResetpasswordComponent } from 'src/app/modules/manager-resetpassword/manager-resetpassword.component';
import { ManagerResetpasswordSuccessComponent } from 'src/app/modules/manager-resetpassword-success/manager-resetpassword-success.component';
import { ManagerResetpasswordExpiredlinkComponent } from 'src/app/modules/manager-resetpassword-expiredlink/manager-resetpassword-expiredlink.component';
import { PolicylistingsComponent } from 'src/app/modules/policylistings/policylistings.component';
import { NgTippyModule } from 'angular-tippy'; import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MessagesComponent } from 'src/app/modules/messages/messages.component';
import { RpaTestComponent } from 'src/app/rpa-test/rpa-test.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog'
import { UpdateAdminComponent } from 'src/app/dialogs/update-admin/update-admin.component';
import { QuoteSummaryComponent } from 'src/app/dialogs/quote-summary/quote-summary.component';
import { ChangePasswordComponent } from 'src/app/dialogs/change-password/change-password.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ResetPasswordComponent } from 'src/app/dialogs/reset-password/reset-password.component';
import { brokersComponent } from 'src/app/modules/brokers/brokers.component';
import { addBrokerComponent } from 'src/app/modules/add-broker/add-broker.component';
import { UpdateBrokerComponent } from 'src/app/dialogs/update-broker/update-broker.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableExporterModule } from 'mat-table-exporter';
import { CurrencyPipe, DatePipe } from '@angular/common';
import {ReportComponent} from 'src/app/modules/report/report.component';
import { BrokerAdminComponent } from 'src/app/modules/broker-admin/broker-admin.component';
import { AddBrokerAdminComponent } from 'src/app/modules/add-broker-admin/add-broker-admin.component';
import { UpdateBrokerAdminComponent } from 'src/app/dialogs/update-broker-admin/update-broker-admin.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FleetMotorAddVehicleComponent } from 'src/app/modules/fleet-motor-add-vehicle/fleet-motor-add-vehicle.component';
import { BillingComponent } from 'src/app/modules/billing/billing.component';
import { UpdateBillingStatusComponent } from 'src/app/dialogs/update-billing-status/update-billing-status.component';


@NgModule({
  declarations: [
    LoginComponent,
    DefaultComponent,
    DashboardComponent,
    AdmitagentComponent,
    PostsComponent,
    CustomersComponent,
    StickerlistingsComponent,
    RegisteredagentsComponent,
    AgtransactionsComponent,
    NewcustomerComponent,
    SendnotificationsComponent,
    ClaimsportalComponent,
    SignupmanagerComponent,
    ManagerstblComponent,
    StickerlistingsComponent,
    PolicylistingsComponent,
    brokersComponent,
    addBrokerComponent,
    // ToolbarComponent,

    // start of set manager set password
    ManagerSetPasswordComponent,
    ManagerExpiredLinkComponent,
    ManagerPasswordsetSuccessComponent,
    ManagerResetpasswordComponent,
    ManagerResetpasswordSuccessComponent,
    ManagerResetpasswordExpiredlinkComponent,
    MessagesComponent,
    RpaTestComponent,
    UpdateAdminComponent,
    QuoteSummaryComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    UpdateBrokerComponent,
    ReportComponent,
    BrokerAdminComponent,
    AddBrokerAdminComponent,
    UpdateAdminComponent,
    UpdateBrokerAdminComponent,
    FleetMotorAddVehicleComponent,
    BillingComponent,
    UpdateBillingStatusComponent



  ],
  entryComponents: [UpdateBrokerComponent, UpdateAdminComponent, QuoteSummaryComponent, ChangePasswordComponent, ResetPasswordComponent, UpdateBrokerAdminComponent, UpdateBillingStatusComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MatSidenavModule,
    MatDividerModule,
    FlexLayoutModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatInputModule,
    MatGridListModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatSortModule,
    MatOptionModule,
    MatSelectModule,
    NgxPaginationModule,
    NgTippyModule,
    MatListModule,
    MatMenuModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatTableExporterModule

  ],

  providers: [
    DashboardService, AuthGuard, ChartService, TpagtService, StickerService, PolicyService, MatDatepickerModule,
    MatNativeDateModule, DatePipe, CurrencyPipe,

    // gexampleService
  ]
})
export class DefaultModule { }
